import React, { FunctionComponent, ReactNode } from 'react';
import { Transition } from 'react-transition-group';

interface FadeProps {
  in: boolean;
  children: ReactNode;
  unmountOnExit?: boolean;
  duration?: number;
}

const Fade: FunctionComponent<FadeProps> = ({
  in: inProp,
  unmountOnExit,
  duration,
  children,
}: FadeProps) => {
  const defaultStyle = {
    transition: `opacity ${duration}ms cubic-bezier(0.50, 0.00, 0.25, 1.00)`,
    opacity: 0,
  };

  const transitionStyles = {
    entering: { opacity: 0 },
    entered: { opacity: 1 },
    exiting: { opacity: 0 },
    exited: { opacity: 0 },
  };

  return (
    <Transition
      in={inProp}
      timeout={duration}
      addEndListener={(node, done) => {
        node.addEventListener('transitionend', done, false);
      }}
      unmountOnExit={unmountOnExit}
    >
      {state => (
        <div
          style={{
            ...defaultStyle,
            ...transitionStyles[state],
          }}
        >
          {children}
        </div>
      )}
    </Transition>
  );
};

Fade.defaultProps = {
  duration: 300,
  unmountOnExit: true,
};

export default Fade;
